module.exports = __webpack_public_path__ + "static/media/accesibility_img-2.bccdcbc3.png";